/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetComponentCodedLookupResponseDto
 */
export interface AssetComponentCodedLookupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentCodedLookupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentCodedLookupResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentCodedLookupResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetComponentCodedLookupResponseDto interface.
 */
export function instanceOfAssetComponentCodedLookupResponseDto(value: object): value is AssetComponentCodedLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetComponentCodedLookupResponseDtoFromJSON(json: any): AssetComponentCodedLookupResponseDto {
    return AssetComponentCodedLookupResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentCodedLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentCodedLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
    };
}

export function AssetComponentCodedLookupResponseDtoToJSON(json: any): AssetComponentCodedLookupResponseDto {
    return AssetComponentCodedLookupResponseDtoToJSONTyped(json, false);
}

export function AssetComponentCodedLookupResponseDtoToJSONTyped(value?: AssetComponentCodedLookupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

